import React from "react";
import styles from "./MasterShiftToolbar.module.css";

const MasterShiftToolbar = ({plantName}) => {
  return (
    <>
      <div className={styles.RgtTools}>
        <div className={styles.eAgsnToolbar}>
          <div className={styles.plantName}>Selected Plant - {plantName}</div>
        </div>
      </div>
    </>
  );
};

export default MasterShiftToolbar;
